interface GenericAssetPreviewProps {
  asset: unknown;
}

export default function GenericAssetPreview({ asset }: Readonly<GenericAssetPreviewProps>) {
  if (!asset) return null;
  return (
    <div>
      <pre>{JSON.stringify(asset, null, 4)}</pre>
    </div>
  );
}
